// tslint:disable-next-line:max-line-length
import { Component, OnInit, AfterViewInit, ViewChild, Output, EventEmitter, Input, ChangeDetectorRef, ViewEncapsulation } from '@angular/core';

import { ModalControl } from '../../../modal-control/modal-control.component';
import { GridColumn, GridExternalFilter, GridBaseOptionFilter } from '../../grid-control.model';
import { SettingService } from '../../../../services/setting/setting.service';
import { TranslateService } from '../../../../services/translate/translate.service';
import { QuickFilter, FilterConfiguration } from './grid-popup-filter.model';
import { NotifyService } from '../../../../services/notify/notify.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { MatSelectChange } from '@angular/material/select';
import { GridPopupQuickFilterDetailComponent } from '../grid-popup-quick-filter-detail/grid-popup-quick-filter-detail.component';
import { MatSelect } from '@angular/material/select';

@Component({
  selector: 'sd-grid-popup-filter',
  templateUrl: './grid-popup-filter.component.html',
  styleUrls: ['../../../../assets/css/form.scss',
    '../../../../assets/css/label.scss',
    '../../../../assets/css/scrollbar.scss',
    './grid-popup-filter.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class GridPopupFilterComponent implements OnInit, AfterViewInit {
  private keyPrefix = 'PopupFilter';
  displayKey = 'SDCUSTOM';
  isMobileOrTablet = false;
  @ViewChild('modal') modal: ModalControl;
  @ViewChild('popupQuickFilterDetail') popupQuickFilterDetail: GridPopupQuickFilterDetailComponent;
  @ViewChild('matSelect') matSelect: MatSelect;
  @Input() key = '';
  @Input() filterOption: GridBaseOptionFilter;
  @Output() accept = new EventEmitter<{ filter: any, externalFilter: any }>();
  @Output() clear = new EventEmitter<void>();
  @Output() loadInlineFilter = new EventEmitter<FilterConfiguration>();
  selectedField: string;
  newQuickFilter = 'e1ef1d43-d689-424f-959e-e6cd154cfee7';
  filter: any = {};
  externalFilter: any = {};
  columns: GridColumn[] = [];
  externalFilters: GridExternalFilter[] = [];
  quickFilters: QuickFilter[] = [];
  selectedCode: string;
  maxQuickFilters = 5;
  @Input() inlineExternal: {
    [key: string]: boolean
  } = {};
  @Input() inlineColumn: {
    [key: string]: boolean
  } = {};
  constructor(
    private ref: ChangeDetectorRef,
    deviceService: DeviceDetectorService,
    private settingService: SettingService,
    private notifyService: NotifyService,
    private translateService: TranslateService
  ) {
    this.isMobileOrTablet = !deviceService.isDesktop();
  }

  ngOnInit() {
    this.loadConfiguration().then(() => {
      this.loadInlineFilter.emit({
        quickFilters: this.quickFilters || [],
        selectedQuickFilter: this.selectedCode || '',
        inlineExternal: this.inlineExternal,
        inlineColumn: this.inlineColumn
      });
    });
  }

  ngAfterViewInit() {

  }

  open = (
    fixedColums: GridColumn[],
    normalColumns: GridColumn[],
    filter: any,
    externalFilter: any,
    externalFilters?: GridExternalFilter[]) => {
    this.init(fixedColums, normalColumns, filter, externalFilter, externalFilters);
    this.modal.open();
  }

  init = (
    fixedColums: GridColumn[],
    normalColumns: GridColumn[],
    filter: any,
    externalFilter: any,
    externalFilters?: GridExternalFilter[]) => {
    this.columns = [...fixedColums, ...normalColumns].filter(e => !e.filter?.disabled && e.type !== 'image');
    this.columns.forEach(column => {
      if (column.type === 'children') {
        column.children = column.children.filter(e => !e.filter?.disabled && e.type !== 'image');
      }
    });
    if (externalFilters) {
      this.externalFilters = externalFilters.filter(e => !e.disabled);
    } else {
      this.externalFilters = [];
    }
    this.filter = filter;
    this.externalFilter = this.initExternalFilter(externalFilters, externalFilter);
    for (const eFilter of this.externalFilters) {
      if (this.inlineExternal[eFilter.field] === undefined) {
        this.inlineExternal[eFilter.field] = true;
      }
    }
    for (const column of this.columns) {
      if (this.inlineColumn[column.field] === undefined) {
        this.inlineColumn[column.field] = true;
      }
    }
  }

  close = () => {
    this.modal.close();
  }

  onAccept() {
    if (this.filterOption?.multiple === false) {
      if (this.selectedField) {
        if (this.selectedField.startsWith('column')) {
          const field = this.selectedField.replace('column', '');
          this.accept.emit({
            filter: {
              [field]: this.filter[field]
            },
            externalFilter: {}
          });
        } else if (this.selectedField.startsWith('external')) {
          const field = this.selectedField.replace('external', '');
          this.accept.emit({
            filter: {},
            externalFilter: this.initExternalFilter(this.externalFilters, {
              [field]: this.externalFilter[field]
            })
          });
        }
      }
    } else {
      this.accept.emit({
        filter: this.filter,
        externalFilter: this.externalFilter
      });
    }
    this.modal.close();
  }

  onClear() {
    delete this.selectedCode;
    this.clear.emit();
  }

  private async loadConfiguration() {
    this.quickFilters = [];
    if (!this.key) {
      return;
    }
    if (!await this.settingService.hasKey(this.keyPrefix + this.key)) {
      return;
    }
    const configuration = await this.settingService.get<FilterConfiguration>(this.keyPrefix + this.key);
    if (Array.isArray(configuration?.quickFilters)) {
      this.quickFilters = configuration.quickFilters;
    }
    this.selectedCode = configuration?.selectedQuickFilter || '';
    this.inlineExternal = configuration?.inlineExternal || {};
    this.inlineColumn = configuration?.inlineColumn || {};
    for (const externalFilter of this.externalFilters) {
      if (this.inlineExternal[externalFilter.field] === undefined) {
        this.inlineExternal[externalFilter.field] = true;
      }
    }
    for (const column of this.columns) {
      if (this.inlineColumn[column.field] === undefined) {
        this.inlineColumn[column.field] = true;
      }
    }
  }

  async updateConfiguration(selectedQuickFilterCode?: string) {
    if (!this.key) {
      return;
    }
    if (selectedQuickFilterCode !== undefined) {
      this.selectedCode = selectedQuickFilterCode;
    }
    await this.settingService.set<FilterConfiguration>(this.keyPrefix + this.key, {
      quickFilters: this.quickFilters,
      selectedQuickFilter: this.selectedCode,
      inlineExternal: this.inlineExternal,
      inlineColumn: this.inlineColumn
    });
    this.loadInlineFilter.emit({
      quickFilters: this.quickFilters || [],
      selectedQuickFilter: this.selectedCode || '',
      inlineExternal: this.inlineExternal,
      inlineColumn: this.inlineColumn
    });
    this.ref.detectChanges();
  }

  onSelectionChange = (change: MatSelectChange) => {
    const value = change?.value || '';
    if (value === this.newQuickFilter) {
      this.selectedCode = '';
      this.onCreateQuickFilter();
      this.ref.detectChanges();
    } else {
      const quickFilter = this.quickFilters.find(e => e.code === value);
      if (quickFilter) {
        this.onDetailQuickFilter(quickFilter);
      }
    }
  }

  onCreateQuickFilter = (ev?: Event) => {
    ev?.stopPropagation();
    ev?.preventDefault();
    this.matSelect?.close();
    this.popupQuickFilterDetail.open(this.columns, this.externalFilters);
  }

  onDetailQuickFilter = async (quickFilter?: QuickFilter) => {
    if (quickFilter) {
      this.selectedCode = quickFilter.code;
      const f1 = JSON.stringify(quickFilter.filter);
      const f2 = JSON.stringify(quickFilter.externalFilter);
      this.filter = JSON.parse(f1);
      this.externalFilter = this.initExternalFilter(this.externalFilters, JSON.parse(f2));
      await this.updateConfiguration();
    }
  }

  onEditQuickFilter = (ev: Event, quickFilter?: QuickFilter) => {
    ev.stopPropagation();
    ev.preventDefault();
    this.matSelect?.close();
    if (quickFilter) {
      this.popupQuickFilterDetail.open(this.columns,
        this.externalFilters,
        quickFilter.filter,
        quickFilter.externalFilter,
        quickFilter.code);
      this.ref.detectChanges();
    }
  }

  onDeleteQuickFilter = (ev: Event, quickFilter?: QuickFilter) => {
    ev.stopPropagation();
    ev.preventDefault();
    this.matSelect?.close();
    if (quickFilter) {
      this.notifyService.confirm(this.translateService.translate('Remove filter')).then(async () => {
        if (quickFilter.code === this.selectedCode) {
          this.selectedCode = '';
        }
        const idx = this.quickFilters.findIndex(e => e.code === quickFilter.code);
        this.quickFilters.splice(idx, 1);
        await this.updateConfiguration();
        this.ref.detectChanges();
      });
    }
  }

  onAcceptQuickFilter = async (args: { code: string, filter: any, externalFilter: any }) => {
    const quickFilter = this.quickFilters.find(e => e.code === args.code);
    if (!quickFilter) {
      this.quickFilters.push({
        code: args.code,
        filter: args.filter,
        externalFilter: this.initExternalFilter(this.externalFilters, args.externalFilter)
      });
    } else {
      quickFilter.filter = args.filter;
      quickFilter.externalFilter = this.initExternalFilter(this.externalFilters, args.externalFilter);
    }
    await this.updateConfiguration();
  }

  onInlineChange = () => {
    this.updateConfiguration();
  }

  private initExternalFilter = (externalFilters: GridExternalFilter[], externalFilter: any) => {
    externalFilter = externalFilter || {};
    externalFilters = externalFilters || [];
    externalFilters.forEach(e => {
      if (e.type === 'string') {
        if (e.default) {
          externalFilter[e.field] = e.default ?? '';
        }
        return;
      }
      if (e.type === 'number') {
        externalFilter[e.field] = externalFilter[e.field] ?? e.default ?? undefined;
        return;
      }
      if (e.type === 'daterange') {
        externalFilter[e.field] = {
          from: externalFilter[e.field]?.from ?? e.defaultFrom ?? undefined,
          to: externalFilter[e.field]?.to ?? e.defaultTo ?? undefined
        };
        return;
      }
      if (e.type === 'numberrange') {
        externalFilter[e.field] = {
          from: externalFilter[e.field]?.from ?? e.defaultFrom ?? undefined,
          to: externalFilter[e.field]?.to ?? e.defaultTo ?? undefined
        };
        return;
      }
      if (e.type === 'daterangefull') {
        externalFilter[e.field] = {
          from: externalFilter[e.field]?.from ?? e.defaultFrom ?? undefined,
          to: externalFilter[e.field]?.to ?? e.defaultTo ?? undefined
        };
        return;
      }
    });
    return externalFilter;
  }
}
